import React, { useEffect, useState } from 'react';
import styles from './Confetti.module.css';

interface ConfettiPiece {
  id: number;
  x: number;
  y: number;
  rotation: number;
  rotationSpeed: number;
  fallSpeed: number;
  color: string;
  size: number;
}

interface ConfettiProps {
  isActive: boolean;
  duration?: number;
}

const COLORS = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff', '#5f27cd'];

export const Confetti: React.FC<ConfettiProps> = ({ isActive, duration = 3000000 }) => {
  const [pieces, setPieces] = useState<ConfettiPiece[]>([]);

  useEffect(() => {
    if (!isActive) {
      setPieces([]);
      return;
    }

    // Create confetti pieces
    const newPieces: ConfettiPiece[] = [];
    for (let i = 0; i < 150; i++) {
      newPieces.push({
        id: i,
        x: Math.random() * 100, // percentage across screen
        y: -10, // start above screen
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 10,
        fallSpeed: 0.5 + Math.random() * 2,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        size: 4 + Math.random() * 8,
      });
    }

    setPieces(newPieces);

    // Animate confetti
    const startTime = Date.now();
    const animate = () => {
      const elapsed = Date.now() - startTime;
      
      if (elapsed < duration) {
        setPieces(prevPieces => 
          prevPieces.map(piece => ({
            ...piece,
            y: piece.y + piece.fallSpeed,
            rotation: piece.rotation + piece.rotationSpeed,
          }))
        );
        requestAnimationFrame(animate);
      } else {
        // Animation complete, keep pieces visible for a bit then fade out
        setTimeout(() => {
          setPieces([]);
        }, 1000);
      }
    };

    requestAnimationFrame(animate);
  }, [isActive, duration]);

  if (!isActive || pieces.length === 0) {
    return null;
  }

  return (
    <div className={styles.confettiContainer}>
      {pieces.map(piece => (
        <div
          key={piece.id}
          className={styles.confettiPiece}
          style={{
            left: `${piece.x}%`,
            top: `${piece.y}%`,
            transform: `rotate(${piece.rotation}deg)`,
            backgroundColor: piece.color,
            width: `${piece.size}px`,
            height: `${piece.size}px`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
